export function parseSyncOffset(value) {
  if (value === '' || value == null) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export function classifySyncResult(result) {
  const offset = parseSyncOffset(result?.sync_offset_sec);
  const noSignal = result?.status === 'no_signal';

  if (noSignal || offset == null) {
    return {
      usable: false,
      offset: null,
      needsReview: true,
      message: result?.recommended_action
        || 'Automatic sync found no usable alignment. Retry detection or enter an offset manually.',
    };
  }

  const needsReview = result?.status === 'low_confidence'
    || result?.needs_manual_review === true;
  return {
    usable: true,
    offset,
    needsReview,
    message: needsReview
      ? (result?.recommended_action
        || 'Automatic sync is low confidence. Check a preview before rendering.')
      : null,
  };
}
